// extracted by mini-css-extract-plugin
module.exports = {"doubleParagraph":"DoubleParagraph-module--doubleParagraph--oHD1C","title":"DoubleParagraph-module--title--3Vw9n","paragraphs":"DoubleParagraph-module--paragraphs--1zbaH"};